export class TaxImportModel {
  counter: number = 0;
  taxTypeCode: string = "";
  code: string = "";
  alterCode: string = "";
  alterCode2: string = "";
  name: string = "";
  rate: number = 0;
  minimumBase: number = 0;
  saleAccount: string = "";
  saleDevolutionAccount: string = "";
  purchaseAccount: string = "";
  purchaseDevolutionAccount: string = "";
  payAccountSelfWithholdingFuente: string = "";
  devolutionAccountSelfWithholdingFuente: string = "";
  departmentCode: string | null = null;
  cityCode: string | null = null;

  constructor(
    counter: number,
    taxTypeCode: string,
    code: string,
    alterCode: string,
    alterCode2: string,
    name: string,
    rate: number,
    minimumBase: number,
    saleAccount: string,
    saleDevolutionAccount: string,
    purchaseAccount: string,
    purchaseDevolutionAccount: string,
    payAccountSelfWithholdingFuente: string,
    devolutionAccountSelfWithholdingFuente: string,
    departmentCode: string | null,
    cityCode: string | null
  ) {
    this.counter = counter;
    this.taxTypeCode = taxTypeCode;
    this.code = code;
    this.alterCode = alterCode;
    this.alterCode2 = alterCode2;
    this.name = name;
    this.rate = rate;
    this.minimumBase = minimumBase;
    this.saleAccount = saleAccount;
    this.saleDevolutionAccount = saleDevolutionAccount;
    this.purchaseAccount = purchaseAccount;
    this.purchaseDevolutionAccount = purchaseDevolutionAccount;
    this.payAccountSelfWithholdingFuente = payAccountSelfWithholdingFuente;
    this.devolutionAccountSelfWithholdingFuente = devolutionAccountSelfWithholdingFuente;
    this.departmentCode = departmentCode;
    this.cityCode = cityCode;
  }
}